import React from "react";
import Helmet from "react-helmet";
import { Permissions } from "thriller-core/Permissions";

import Header from "./header";
import WithAuthentication from "../components/WithAuthentication";
import WithPermission from "../components/WithPermission";

import "./index.css";

const IndexWrapper = ({ location, children }) => (
  <div>
    <Helmet
      title="Cliffhanger: Thrilling Chat Stories"
      meta={[
        { name: "description", content: "Cliffhanger: Thrilling Chat Stories" },
        { name: "keywords", content: "Cliffhanger Thrilling Chat Stories" }
      ]}
    >
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
    </Helmet>
    <div>
      {!location.pathname.startsWith("/admin") && children()}
      {location.pathname.startsWith("/admin") && (
        <WithAuthentication>
          <WithPermission permission={Permissions.ADMIN}>
            <Header />
            <div>{children()}</div>
          </WithPermission>
        </WithAuthentication>
      )}
    </div>
  </div>
);

export default IndexWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js